import { render, staticRenderFns } from "./FigmaAPIGenerateToken.vue?vue&type=template&id=05141b47&scoped=true&"
import script from "./FigmaAPIGenerateToken.vue?vue&type=script&lang=js&"
export * from "./FigmaAPIGenerateToken.vue?vue&type=script&lang=js&"
import style0 from "./FigmaAPIGenerateToken.vue?vue&type=style&index=0&id=05141b47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05141b47",
  null
  
)

export default component.exports